import { render, staticRenderFns } from "./UserAuditTrailView.vue?vue&type=template&id=f1220cd4&scoped=true"
import script from "./UserAuditTrailView.vue?vue&type=script&lang=ts"
export * from "./UserAuditTrailView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1220cd4",
  null
  
)

export default component.exports